module.exports = __webpack_public_path__ + "static/media/susannah-zawko.c9d87e1e.jpg";